import Vue from 'vue'
import Router from 'vue-router'
import guards from './guards'

import CONFIG from '../config'

import { initRouter } from '@router/tools'

Vue.use(Router);

const indexs = initRouter();

var router = new Router({
    routes: [
        {
            path: '/demo/vcm',
            component: () => import(/*webpackChunkName: 'demo-vcm'*/ '@components/example')
        },
        {
            path: '/login',
            component: () => import(/*webpackChunkName: 'pc-login'*/ '@views/login/index'),
            meta: {
                title: `登录`
            }
        },
        {
            path: '/home',
            component: () => import(/*webpackChunkName: 'pc-home'*/ '@views/home/index'),
            meta: {
                title: window._config['title']
            }
        },
        {
            path: `/${CONFIG.router['base-name']}`,
            component: () => import(/*webpackChunkName: 'pc'*/ '@layout/empty'),
            meta: {
                title: window._config['title']
            },
            children: [
                ...indexs,
                {
                    path: ``,
                    component: () => import(/*webpackChunkName: 'pc'*/ '@views/layout/index'),
                    children: [
                        {
                            path: 'iframe',
                            alias:'/iframe',
                            component: () => import(/*webpackChunkName: 'iframe'*/ '@views/iframe'),
                            meta: {
                                title: '',
                                bread: []
                            }
                        },
                    ]
                }
            ]
        }
    ]
});

guards(router);

export default router